/**
 * Contact Lists API - operations with contact lists (lead-based)
 */
import apiClient from '../client.js';

/**
 * Получить список всех списков контактов
 * @param {Object} [params] - Query параметры (owner, teamId, managerId)
 * @returns {Promise<Object>} - Полный ответ с items, userRole, teams, managers
 */
export async function getContactLists(params) {
  const { data } = await apiClient.get('/outreach/contact-lists', { params });
  return data;
}

/**
 * Получить детали списка контактов (с лидами)
 * @param {string} listId
 * @param {Object} [params] - Query параметры (page, limit, search)
 * @returns {Promise<Object>}
 */
export async function getContactListDetails(listId, params) {
  const { data } = await apiClient.get(`/outreach/contact-lists/${listId}`, { params });
  return data;
}

/**
 * Создать новый список контактов
 * @param {Object} payload - { name, description, source }
 * @returns {Promise<Object>}
 */
export async function createContactList(payload) {
  const { data } = await apiClient.post('/outreach/contact-lists', payload);
  return data;
}

/**
 * Обновить список контактов
 * @param {string} listId
 * @param {Object} payload - { name, description, source }
 * @returns {Promise<Object>}
 */
export async function updateContactList(listId, payload) {
  const { data } = await apiClient.patch(`/outreach/contact-lists/${listId}`, payload);
  return data;
}

/**
 * Удалить список контактов
 * @param {string} listId
 * @returns {Promise<void>}
 */
export async function deleteContactList(listId) {
  await apiClient.delete(`/outreach/contact-lists/${listId}`);
}

/**
 * Добавить лидов в список
 * @param {string} listId
 * @param {string[]} leadIds - массив UUID лидов
 * @returns {Promise<Object>} - { ok, added }
 */
export async function addLeadsToList(listId, leadIds) {
  const { data } = await apiClient.post(`/outreach/contact-lists/${listId}/leads`, { leadIds });
  return data;
}

/**
 * Удалить лида из списка
 * @param {string} listId
 * @param {string} leadId
 * @returns {Promise<void>}
 */
export async function removeLeadFromList(listId, leadId) {
  await apiClient.delete(`/outreach/contact-lists/${listId}/leads/${leadId}`);
}

/**
 * Добавить всех лидов по фильтрам в список
 * @param {string} listId
 * @param {Object} filters - те же фильтры что GET /leads (search, status, scout, etc.)
 * @returns {Promise<Object>} - { ok, added, total }
 */
export async function addLeadsToListFromFilters(listId, filters) {
  const { data } = await apiClient.post(`/outreach/contact-lists/${listId}/bulk-add`, { filters });
  return data;
}

// DEPRECATED: backward-compat aliases (will be removed in 28-02/28-03)
export const addContacts = (listId, _payload) => {
  console.warn('[DEPRECATED] addContacts — use addLeadsToList');
  return Promise.resolve({ ok: true, added: 0 });
};
export const removeContact = (listId, _contactId) => {
  console.warn('[DEPRECATED] removeContact — use removeLeadFromList');
  return Promise.resolve();
};
export const addContactsFromFilters = (listId, _params) => {
  console.warn('[DEPRECATED] addContactsFromFilters — removed');
  return Promise.resolve({ ok: true, addedCount: 0 });
};

// Phase 97.8 W2: getInstantlyAccounts / getInstantlyCampaigns / syncInstantlyCampaigns /
// createInstantlyCampaign removed — all backend /outreach/campaigns/instantly* routes were
// deleted in Wave 1.
